/**
 * Translation OUTSIDE React: hooks, helpers, toasts and API error mapping that run when an
 * event fires, not during render. `I18nProvider` points this at the active translator, so a
 * call made after a language change speaks the new language.
 *
 * Inside a component, use `useT()` instead: it re-renders the component when the language
 * changes, and this does not. Never call `translate()` at MODULE LOAD (a top-level constant):
 * it would freeze the text in whatever language was active when the file was imported. Store
 * the KEY in the constant and translate where it is shown.
 */
import { DEFAULT_LOCALE, type AppLocale } from "@shared/i18n/localeConfig";
import { EN_CATALOG, type MessageKey } from "./englishCatalog";
import { Translator, type MessageValues } from "./translator";

let active = new Translator({ locale: DEFAULT_LOCALE, messages: EN_CATALOG, fallback: EN_CATALOG });

export function setActiveTranslator(translator: Translator): void {
  active = translator;
}

export function translate(key: MessageKey, values?: MessageValues): string {
  return active.t(key, values);
}

export function activeLocale(): AppLocale {
  return active.locale;
}
